export default "__VITE_ASSET__WeemhKz7__"